import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { hapticSelection } from "@/lib/capacitor";

interface BackButtonProps {
  readonly onBack?: () => void;
}

export default function BackButton({ onBack }: BackButtonProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="bg-white rounded-full p-2 cursor-pointer shadow-md"
      onClick={() => {
        void hapticSelection();
        if (onBack) {
          onBack();
          return;
        }

        navigate(-1);
      }}
      aria-label="Go back"
    >
      <ChevronLeft strokeWidth={1} />
    </button>
  );
}
